/* While an admin lists a NEW property, the unique experience tags are chosen on the first screen, before the property
   has an id. They wait here, in the browser, until the listing is confirmed and the id is known. */

export const DRAFT_KEY = 'unique_stay_tag_draft';

type Store = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

const defaultStore = (): Store | undefined => (typeof window !== 'undefined' ? window.sessionStorage : undefined);

/** The saved tag ids, or null when there is no draft. A draft with no ids is a real answer ("none"), not "no draft". */
export const readDraft = (store: Store | undefined = defaultStore()): number[] | null => {
  try {
    const raw = store?.getItem(DRAFT_KEY);
    if (raw === null || raw === undefined) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return null;
    return parsed.filter((id) => Number.isInteger(id) && id > 0);
  } catch (_) {
    return null;
  }
};

export const writeDraft = (ids: number[], store: Store | undefined = defaultStore()): void => {
  try {
    store?.setItem(DRAFT_KEY, JSON.stringify(ids));
  } catch (_) {
    /* blocked storage: the tags can still be added later in the admin page */
  }
};

export const clearDraft = (store: Store | undefined = defaultStore()): void => {
  try {
    store?.removeItem(DRAFT_KEY);
  } catch (_) {
    /* nothing to do */
  }
};
